import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Building2, Mail, Phone, MapPin, FileText } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AvisoLegalPage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a]">
        <div className="max-w-4xl mx-auto px-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Volver al inicio
          </Link>
          
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-12 rounded-full bg-[#e4002b]/20 flex items-center justify-center">
              <FileText className="w-6 h-6 text-[#e4002b]" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold">Aviso Legal</h1>
          </div>
          
          <p className="text-white/60 text-sm">
            Última actualización: Febrero 2026
          </p>
        </div>
      </section>
      
      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-6">
          <div className="space-y-10">
            
            {/* Section 1 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">1</span>
                INFORMACIÓN IDENTIFICATIVA
              </h2>
              
              <p className="text-white/70 mb-6 leading-relaxed">
                En cumplimiento con el deber de información recogido en el artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, a continuación se reflejan los siguientes datos:
              </p>
              
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <div className="flex items-center gap-3 mb-2">
                    <Building2 className="w-4 h-4 text-[#e4002b]" />
                    <span className="text-white/50 text-sm">Titular del sitio web</span>
                  </div>
                  <p className="font-semibold">Versión Digital S.L.</p>
                </div>
                
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <div className="flex items-center gap-3 mb-2">
                    <FileText className="w-4 h-4 text-[#e4002b]" />
                    <span className="text-white/50 text-sm">C.I.F.</span>
                  </div>
                  <p className="font-semibold">B98660459</p>
                </div>
                
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <div className="flex items-center gap-3 mb-2">
                    <MapPin className="w-4 h-4 text-[#e4002b]" />
                    <span className="text-white/50 text-sm">Domicilio social</span>
                  </div>
                  <p className="font-semibold">Calle Martínez Ferrando 6, CD. 46004, Valencia</p>
                </div>
                
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <div className="flex items-center gap-3 mb-2">
                    <FileText className="w-4 h-4 text-[#e4002b]" />
                    <span className="text-white/50 text-sm">Registro Mercantil</span>
                  </div>
                  <p className="font-semibold text-sm">Tomo 9841, Libro 7123, Folio 13, Hoja V-161127</p>
                </div>
                
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <div className="flex items-center gap-3 mb-2">
                    <Mail className="w-4 h-4 text-[#e4002b]" />
                    <span className="text-white/50 text-sm">Correo electrónico</span>
                  </div>
                  <a href="mailto:administracion@versiondigital.es" className="font-semibold text-[#e4002b] hover:underline">
                    administracion@versiondigital.es
                  </a>
                </div>
                
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <div className="flex items-center gap-3 mb-2">
                    <Phone className="w-4 h-4 text-[#e4002b]" />
                    <span className="text-white/50 text-sm">Teléfono</span>
                  </div>
                  <a href="tel:961820328" className="font-semibold text-[#e4002b] hover:underline">
                    961 82 03 28
                  </a>
                </div>
              </div>
            </div>
            
            {/* Section 2 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">2</span>
                USUARIOS Y CONDICIONES DE USO
              </h2>
              <div className="text-white/70 space-y-4 leading-relaxed">
                <p>
                  El acceso y/o uso de este portal de Versión Digital S.L. atribuye la condición de USUARIO, que acepta, desde dicho acceso y/o uso, las Condiciones Generales de Uso aquí reflejadas. Las citadas Condiciones serán de aplicación independientemente de las Condiciones Generales de Contratación que en su caso resulten de obligado cumplimiento.
                </p>
                <p>
                  El portal www.cinemastreaming.es proporciona el acceso a multitud de informaciones, servicios o datos (en adelante, "los contenidos") en Internet pertenecientes a Versión Digital S.L. o a sus licenciantes a los que el USUARIO pueda tener acceso.
                </p>
              </div>
            </div>
            
            {/* Section 3 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">3</span>
                PROPIEDAD INTELECTUAL E INDUSTRIAL
              </h2>
              <div className="text-white/70 space-y-4 leading-relaxed">
                <p>
                  Versión Digital S.L. por sí o como cesionaria, es titular de todos los derechos de propiedad intelectual e industrial de su página web, así como de los elementos contenidos en la misma (a título enunciativo: imágenes, sonido, audio, vídeo, software o textos; marcas o logotipos, combinaciones de colores, estructura y diseño, selección de materiales usados, programas de ordenador necesarios para su funcionamiento, acceso y uso, etc.).
                </p>
                <div className="bg-[#e4002b]/10 border border-[#e4002b]/30 rounded-lg p-4 mt-4">
                  <p className="text-white/90 font-medium">
                    Queda expresamente prohibida la reproducción, distribución y comunicación pública, incluida su modalidad de puesta a disposición, de la totalidad o parte de los contenidos de esta página web, con fines comerciales, en cualquier soporte y por cualquier medio técnico, sin la autorización previa y por escrito de Versión Digital S.L.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Section 4 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">4</span>
                EXCLUSIÓN DE GARANTÍAS Y RESPONSABILIDAD
              </h2>
              <p className="text-white/70 leading-relaxed">
                Versión Digital S.L. no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier naturaleza que pudieran ocasionar, a título enunciativo: errores u omisiones en los contenidos, falta de disponibilidad del portal o la transmisión de virus o programas maliciosos o lesivos en los contenidos, a pesar de haber adoptado todas las medidas tecnológicas necesarias para evitarlo.
              </p>
            </div>
            
            {/* Section 5 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">5</span>
                ENLACES (LINKS)
              </h2>
              <p className="text-white/70 leading-relaxed">
                En el caso de que en www.cinemastreaming.es se dispusiesen enlaces o hipervínculos hacía otros sitios de Internet, Versión Digital S.L. no ejercerá ningún tipo de control sobre dichos sitios y contenidos. En ningún caso Versión Digital S.L. asumirá responsabilidad alguna por los contenidos de algún enlace perteneciente a un sitio web ajeno.
              </p>
            </div>
            
            {/* Section 6 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">6</span>
                PROTECCIÓN DE DATOS
              </h2>
              <p className="text-white/70 leading-relaxed">
                Versión Digital S.L. cumple con las directrices del Reglamento General de Protección de Datos (RGPD) 2016/679 y la Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales. Para más información sobre el tratamiento de sus datos, consulte nuestra{' '}
                <Link to="/politica-privacidad" className="text-[#e4002b] hover:underline font-medium">
                  Política de Privacidad
                </Link>.
              </p>
            </div>
            
            {/* Section 7 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">7</span>
                EMPLEO DE COOKIES
              </h2>
              <p className="text-white/70 leading-relaxed">
                Versión Digital S.L. podrá utilizar cookies para personalizar y facilitar al máximo la navegación del USUARIO por su portal. Para más información, consulte nuestra{' '}
                <Link to="/politica-cookies" className="text-[#e4002b] hover:underline font-medium">
                  Política de Cookies
                </Link>.
              </p>
            </div>
            
            {/* Section 8 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">8</span>
                DERECHO DE EXCLUSIÓN
              </h2>
              <p className="text-white/70 leading-relaxed">
                Versión Digital S.L. se reserva el derecho a denegar o retirar el acceso al portal y/o los servicios ofrecidos sin necesidad de preaviso, a instancia propia o de un tercero, a aquellos usuarios que incumplan las presentes Condiciones Generales de Uso.
              </p>
            </div>
            
            {/* Section 9 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">9</span>
                LEGISLACIÓN APLICABLE Y JURISDICCIÓN
              </h2>
              <p className="text-white/70 leading-relaxed">
                La relación entre Versión Digital S.L. y el USUARIO se regirá por la normativa española vigente y cualquier controversia se someterá a los Juzgados y tribunales de la ciudad de Madrid, salvo que la ley aplicable disponga otra cosa.
              </p>
            </div>
            
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default AvisoLegalPage;
